<template>
  <div class="wrapper-banner">
    <!-- Banner Section -->
    <section
      class="banner-first"
      :style="{
        backgroundImage: `url(${require('@/assets/images/img/deheus-1-land.webp')})`,
      }"
    >
      <h1 class="title-home">
        ASSET PROPERTY <br />
        DE HEUS INDONESIA
      </h1>
    </section>

    <!-- Floating Filter Box -->
    <div class="filter-box">
      <!-- City -->
      <div class="flex-style">
        <label>KOTA</label>
        <select ref="citySelect" class="w-full" :disabled="loading"></select>
      </div>

      <!-- Type -->
      <div class="flex-style">
        <label>TIPE</label>
        <select ref="typeSelect" class="w-full" :disabled="loading"></select>
      </div>

      <!-- Button Filter -->
      <div class="box-w">
        <button class="btn-filter" @click="applyFilter" :disabled="loading">
          <span v-if="!loading">SEARCH</span>
          <span v-else>Loading...</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "select2/dist/css/select2.min.css";
import "select2";

export default {
  name: "BannerComp",
  data() {
    return {
      // Dummy jika API NULL
      dummyCities: ["Jakarta", "Bandung", "Surabaya", "Medan"],
      dummyTypes: ["Apartment", "House", "Villa", "Office"],

      cities: [],
      types: [],

      selectedCity: null,
      selectedType: null,
    };
  },
  async mounted() {
    await this.loadCities();
    await this.loadTypes();

    // Init Select2 City
    $(this.$refs.citySelect).append("<option></option>");
    $(this.$refs.citySelect)
      .select2({
        data: this.cities.map((c) => ({ id: c.id || c, text: c.text || c })),
        placeholder: "Select City",
        allowClear: true,
        dropdownParent: $(this.$el.querySelector(".filter-box")),
        width: "100%",
      })
      .on("change", (e) => {
        this.selectedCity = e.target.value;
      });

    // Init Select2 Type
    $(this.$refs.typeSelect).append("<option></option>");
    $(this.$refs.typeSelect)
      .select2({
        data: this.types.map((t) => ({ id: t.code || t, text: t.name || t })),
        placeholder: "Select Type",
        allowClear: true,
        dropdownParent: $(this.$el.querySelector(".filter-box")),
        width: "100%",
      })
      .on("change", (e) => {
        this.selectedType = e.target.value;
      });
  },
  beforeUnmount() {
    $(this.$refs.citySelect).select2("destroy");
    $(this.$refs.typeSelect).select2("destroy");
  },
  methods: {
    // Load Kota
    async loadCities() {
      try {
        const res = await fetch("https://cms-property.cjfnc.id/api/post-data");
        const json = await res.json();

        if (json?.data?.length) {
          // Ambil hanya district_id & district_name unik
          const unique = {};

          json.data.forEach((item) => {
            if (item.district_id && item.district_name) {
              unique[item.district_id] = item.district_name;
            }
          });

          // Convert ke array untuk Select2
          this.cities = Object.keys(unique).map((key) => ({
            id: key,
            text: unique[key],
          }));
        } else {
          // Fallback ke dummy
          this.cities = this.dummyCities.map((c) => ({ id: c, text: c }));
        }
      } catch (e) {
        // Error fallback dummy
        this.cities = this.dummyCities.map((c) => ({ id: c, text: c }));
      }
    },

    // Load Tag / Type
    async loadTypes() {
      try {
        const res = await fetch("https://cms-property.cjfnc.id/api/tag");
        const json = await res.json();

        this.types = json?.data?.length ? json.data : this.dummyTypes;
      } catch (e) {
        this.types = this.dummyTypes; // fallback
      }
    },

    applyFilter() {
      const query = {};

      if (this.selectedCity) query.city = this.selectedCity;
      if (this.selectedType) query.type = this.selectedType;

      this.$router.push({
        path: "/asset",
        query: query,
      });
    },
  },
};
</script>

<style>
.mobile {
  display: none;
}
/* Sidebar Style */
.wrapper-banner {
  position: relative;
  background: #fff;
  height: 93vh;
}
.title-home {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  font-size: 48px;
}
.banner-first {
  position: relative;
  height: 70vh;
  background-size: cover;
  background-position: bottom;
  background-attachment: fixed;
  clip-path: ellipse(70% 88% at 50% 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
  overflow: hidden;
}

/* Layer hitam transparan */
.banner-first::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.45); /* atur transparansi di sini */
  z-index: 1;
}

/* Supaya content tetap di atas overlay */
.banner-first > * {
  position: relative;
  z-index: 2;
}
.filter-box {
  width: 90%; /* responsive */
  max-width: 950px; /* batas maksimal */
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: -5%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  border-radius: 8px;
  border: 1px solid #a0a0a0;
  padding: 20px;
  z-index: 101;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
}
.flex-style {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35%;
  margin-right: 10px;
}

.flex-style label {
  padding: 3px 20px;
  white-space: nowrap;
  background: #a0a0a0;
  border-radius: 4px 0px 0px 4px;
  color: #fff;
}

.select2-dropdown {
  /* max-width: 100% !important;
  width: auto !important; */
  box-sizing: border-box;
  overflow-x: hidden; /* cegah scrollbar horizontal */
}

/* Parent container juga dibatasi */
.select2-container {
  max-width: 100% !important;
}

.select2-container--default .select2-selection--single {
  width: 100% !important;
}
.box-w {
  width: 30%;
}
.btn-filter {
  padding: 10px;
  background: #006dcd;
  border: none;
  border-radius: 8px;
  width: 100%;
  color: #fff;
  font-weight: 600;
  letter-spacing: 1px;
  cursor: pointer;
}

.select2-container--default .select2-selection--single {
  background-color: #fff;
  border: 1px solid #aaa;
  border-radius: 0px 4px 4px 0px;
}

section {
  background: #000;
  display: none;
  color: #fff;
  position: absolute;
  margin: 0 auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
section:first-of-type {
  display: block;
}
.center-content {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
  height: 100%;
}
.sidebar-banner {
  position: absolute;
  z-index: 1000;
  background: transparent;
  height: 100%;
  width: 10%;
}
.list-abso {
  padding: 10px 20px 40px 20px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 50px;
  width: 55%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-20%, -50%);
}
ul.list-abso {
  list-style: none;
}
.list-abso li {
  width: 100%;
  text-align: center;
  color: #fff;
  cursor: pointer;
  position: relative;
  margin: 90px 0px;
}
.title-menu {
  color: #002744;
  position: relative;
  top: 45px;
  font-size: 12.5px;
  letter-spacing: 1px;
  font-weight: 500;
}
.active .title-menu {
  font-weight: 700;
}
.active .circle {
  background: #238e73;
  transition: all 0.5s ease;
}
.active .circle i {
  color: #fff;
  transition: all 0.5s ease;
}
.active .circle img {
  color: #fff;
  transition: all 0.5s ease;
}
.active .circle:before,
.active .circle:after {
  animation: none;
}
.active .circle:after {
  opacity: 1;
  transform: scale(0.7);
  border: 3px solid #238e73;
}
h4 {
  padding: 0;
  margin: 0;
}
.circle i {
  font-size: 25px;
  display: inline-block;
  vertical-align: middle;
  margin-top: -28px;
  color: #238e73;
  transition: all 0.5s ease;
}
.circle img {
  font-size: 25px;
  display: inline-block;
  vertical-align: middle;
  margin-top: -27px;
  color: #238e73;
  transition: all 0.5s ease;
}
.circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 55px;
  height: 55px;
  background: #fff;
  color: #fff;
  border-radius: 50%;
  text-align: center;
  line-height: 80px;
  transition: all 0.5s ease;
}
.circle:before,
.circle:after {
  content: "";
  display: block;
  position: absolute;
  border: 50%;
  border: 2px solid #fff;
  left: -20px;
  right: -20px;
  top: -20px;
  bottom: -20px;
  border-radius: 50%;
  animation: animate 1.5s linear infinite;
  opacity: 0;
  backface-visibility: hidden;
}

.circle:after {
  animation-delay: 0.5s;
}

@keyframes animate {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(1.2);
    opacity: 0;
  }
}
/* End Sidebar Style */

/* Banner First */
.banner-first {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
}
/* .banner-first::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, #1c0522, transparent);
  z-index: 11;
} */
.banner-first img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.banner-first-mobile {
  display: none;
}
/* .banner-first img#moon {
  mix-blend-mode: screen;
} */
.banner-first img#mountain_first {
  z-index: 10;
}
/* End Banner First */
@media (max-width: 1600px) {
}
@media (max-width: 1440px) {
  .title-wrap .circle-title {
    left: 39%;
  }
  .list-abso {
    width: 65%;
  }
}
@media (max-width: 1370px) {
  .list-abso li {
    margin: 80px 0px;
  }
  .title-menu {
    margin-left: -2px;
  }
}
@media (max-width: 1285px) {
  .list-abso {
    width: 60%;
  }
  .list-abso li {
    margin: 70px 0px !important;
  }
  .title-menu {
    font-size: 10.5px;
  }
  .title-home {
    width: 80%;
  }
  .wrapper-blog {
    padding: 100px 40px 70px 40px;
  }
  .wrapper-content-blog {
    column-gap: 10px;
  }
  .wrapper-content-blog .box {
    margin: 10px 10px !important;
  }
}
@media (max-width: 1200px) {
  .circle {
    width: 45px;
    height: 45px;
  }
  .list-abso li:nth-child(1) .circle img {
    margin-top: -40px;
  }
  .circle img {
    margin-top: -32px;
  }
}
@media (max-width: 1100px) {
  .wrapper-banner {
    height: 35vh;
  }
  .sidebar-banner {
    width: 100%;
    height: auto;
    bottom: 20px;
  }
  .list-abso {
    width: 80%;
    display: flex;
    padding: 15px 20px 35px 20px;
  }

  .list-abso li {
    margin: 0px 0px !important;
  }
  .circle {
    width: 35px;
    height: 35px;
  }

  .circle img {
    margin-top: -44px;
    width: 22px;
    object-fit: contain;
  }
  .list-abso li:nth-child(1) .circle img {
    margin-top: -48px;
  }
  .list-abso li {
    margin: 60px 0px !important;
  }
  .list-abso {
    width: 70%;
  }
  .title-menu {
    top: 35px;
  }
  .sidebar-banner {
    top: 10%;
    left: 0%;
    transform: translate(0%, 0%);
    position: relative;
  }
  .list-abso {
    position: relative;
    top: 0%;
    left: 0%;
    transform: translate(0%, 0%);
    margin: auto;
    width: 90%;
  }
  .list-abso li {
    margin: 5px 0px !important;
  }
  .list-abso li:nth-child(1) .circle img {
    margin-top: -48px;
    width: 17px;
  }

  .wrapper-banner {
    height: auto;
    min-height: 80vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url(http://localhost:8081/images/img/cjfnc-1.jpg);
    padding: 120px 10px 70px 10px;
    background-position: bottom;
  }
  .wrapper-banner.homes {
    height: auto;
    min-height: 50vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url(../../../public/images/layer-1.png);
    padding: 120px 10px 70px 10px;
  }
  .wrapper-banner.pohon {
    height: auto;
    min-height: 50vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url(../../../public/images/trees/trees-bg.png);
    padding: 120px 10px 70px 10px;
  }
  .wrapper-banner.rivers {
    height: auto;
    min-height: 50vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url(../../../public/images/rivers/bg-rivers.png);
    padding: 120px 10px 70px 10px;
  }
  .wrapper-banner.rocks {
    height: auto;
    min-height: 50vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url(../../../public/images/rocks/bg-rocks.png);
    padding: 120px 10px 70px 10px;
  }
}

@media screen and (max-width: 1024px) {
  .filter-box {
    flex-wrap: wrap;
    width: 95%;
    bottom: -6%;
    padding: 15px;
  }

  .flex-style,
  .box-w {
    width: 100%;
    margin-bottom: 10px;
  }
  header img {
    margin-top: 0px;
  }
  .wrapper-blog {
    padding: 120px 20px 70px 20px !important;
  }
  .wrapper-content-blog {
    column-gap: 10px;
    grid-template-columns: repeat(6, 1fr);
  }
  .wrapper-content-blog .box {
    margin: 10px 5px !important;
  }
}

@media (max-width: 992px) {
  .wrapper-banner {
    height: auto;
  }
  .sidebar-banner {
    width: 100%;
    height: auto;
    bottom: 20px;
  }
  .list-abso {
    width: 80%;
    display: flex;
    padding: 20px 20px 35px 20px;
  }

  .list-abso li {
    margin: 0px 0px !important;
  }
  section:first-of-type {
    display: none;
  }
  .filter-box {
    bottom: -7%;
  }
}
@media (max-width: 600px) {
  .circle {
    width: 30px;
    height: 30px;
  }
  .circle img {
    margin-top: -50px;
    width: 20px;
  }
  .list-abso li:nth-child(1) .circle img {
    margin-top: -53px;
    width: 17px;
  }

  .wrapper-banner {
    height: auto;
    min-height: 50vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url(http://localhost:8081/images/img/cjfnc-1.jpg);
    padding: 120px 10px 70px 10px;
  }
  .banner-first {
    height: auto;
    background-color: transparent;
  }
  .banner-first img {
    display: none;
  }
  .banner-first .mobile {
    height: auto;
  }
  .sidebar-banner {
    top: 10%;
    left: 0%;
    transform: translate(0%, 0%);
    position: relative;
  }
  .list-abso {
    position: relative;
    top: 0%;
    left: 0%;
    transform: translate(0%, 0%);
    margin: auto;
    width: 99%;
  }
  .list-abso li {
    margin: 5px 0px !important;
  }
  .wrapper-content-blog .box {
    grid-column: span 8;
  }
  .filter-box {
    bottom: -16%;
  }
  header img {
    margin-top: 3px;
  }
}
@media (max-width: 380px) {
  .list-abso {
    width: 99%;
  }
  .card-box .box .boxie p {
    font-size: 12px;
  }
  .card-box .box .boxie:nth-child(2) img {
    width: 80%;
  }
  .title-menu {
    margin-left: 3px;
  }
  .filter-box {
    bottom: -20%;
  }
  .wrapper-blog {
    padding: 120px 10px 70px 10px;
  }
  .card-box-2 img {
    width: 60%;
  }
  .card-box-2 .box-2 .boxie-2 p {
    font-size: 12px;
  }

  .wrapper-content-blog .box {
    grid-column: span 8;
  }
}
</style>
